import Draggable from 'react-draggable';
import { CallingState, useCallStateHooks } from '@stream-io/video-react-sdk';
import { RingingCallComponent } from '../../Calls/incoming-call';
import { SpeakerView } from '../../Calls/call-layout';


function CallComponent() {
    const { useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState();

    switch (callingState) {
        case CallingState.RINGING:
            return <RingingCallComponent />
        case CallingState.JOINING:
            return <RingingCallComponent />
        default:
            return (
                <SpeakerView />
            )
    }
}

const CallSection = () => {
    return (
        <Draggable cancel="button">
            <div>
                <CallComponent />
            </div>
        </Draggable>
    );
};

export default CallSection;
